module.exports = __webpack_public_path__ + "img/t1-min.87d84b7e.png";